module.exports = __webpack_public_path__ + "static/media/README.346888c5.md";